module.exports = __webpack_public_path__ + "static/media/icon_react.0892053f.png";